import React from 'react'
import { Menu, Dropdown, Button } from 'antd'
import { connect } from 'react-redux'
import { Route, withRouter } from 'react-router-dom'
import axios from 'axios'
import { AuthAPI } from 'services/login'
import store from 'store'
import { Common } from 'services/common'
import Scopes from 'services/scope'
import ClusterService from 'services/cluster_apis'
import RouteAccess from 'services/route_access'
import Conf from 'ui-config'
import style from './style.module.scss'
import blooCommandIcon from '../../../system/Auth/img/bloo-icon-white.svg'
import blooCommandIconPink from '../../../system/Auth/img/bloo-icon-pink.svg'

const BLOO_COMMAND_URL = Conf.HOST + Conf.LC_IP + '/lc/users/handoff/start'

const mapStateToProps = ({ menu, settings, user }) => ({
  menuData: menu.menuData,
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
  role: user.role,
  selectedCluster: user.selectedCluster,
  selectedScope: user.selectedScope,
  selectedPage: store.get('app.menu.selectedKeys'),
  AllAccessData: user.AllAccessData,
  tenantsData: [],
})

const dispatchToProps = dispatch => {
  return {
    updateScopeData: newData => {
      dispatch({ type: 'user/SET_SCOPEDETAILS', payload: newData })
    },
    updateSelection: (data, allData) => {
      dispatch({
        type: 'user/SET_STATE',
        payload: {
          selectedCluster: data.cluster,
          selectedScope: data.scope,
          AllAccessData: allData,
          eulaStatus: allData.data.EULA,
        },
      })
    },
    updateUserRole: str => {
      dispatch({
        type: 'user/SET_STATE',
        payload: {
          role: str,
        },
      })
    },
    updateAcc: data =>
      dispatch({
        type: 'user/SET_ACCDETAILS',
        payload: { selectedCluster: data.cluster, selectedScope: data.scope },
      }),
  }
}

@withRouter
@connect(mapStateToProps, dispatchToProps)
class ClusterScopetab extends React.Component {
  state = {
    // selectedCluster: Common.getSelectedCluster(),
    SelectedScope: {},
    SSID: localStorage.getItem('SSID'),
    clusterName: {},
    // ClusterData: Common.getClusterData(),
    // scopeList: Common.getScopeList(),
    // enabledScopelist: Common.getEnabledScopes(),
    accessData: {},
    routesMap: {},
    blooCommandHover: false,
  }

  updateUserAccessAndClusterScope = getAccData => {
    var acc = getAccData.data
    var accArr = []
    for (var i = 0; i < acc.data.access.length; i++) {
      accArr.push(acc.data.access[i])
    }
    acc.data.access = accArr
    this.setState({ accessData: acc })
    var responseData = getAccData.data
    var urlData = this.props.location.pathname.split('/')
    var selectCls = {}
    var selectScop = {}
    for (var i = 0; i < responseData.data.access.length; i++) {
      if (responseData.data.access[i].clusterId === urlData[1]) {
        selectCls = responseData.data.access[i]
        for (var j = 0; j < responseData.data.access[i].scope_access.length; j++) {
          if (responseData.data.access[i].scope_access[j].scope_id === urlData[2]) {
            selectScop = responseData.data.access[i].scope_access[j]
          }
        }
      }
    }
    this.setState({ clusterName: selectCls })
    this.setState({ SelectedScope: selectScop })
    var dat = { cluster: selectCls, scope: selectScop }
    this.props.updateSelection(dat, acc)
    var accessStr = ''
    if (acc.data) {
      if (acc.data.isRoot) {
        if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
          if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN}`
          }
        } else if (Object.keys(selectScop).length > 0) {
          accessStr = `${RouteAccess.ROOT} - ${selectScop.role}`
        } else {
          accessStr = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
        }
      } else if (acc.data.isOrgAdmin) {
        if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
          if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN}`
          }
        } else if (Object.keys(selectScop).length > 0) {
          accessStr = `${RouteAccess.ORG_ADMIN} - ${selectScop.role}`
        } else {
          accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
        }
      } else if (acc.data.userType === RouteAccess.CONTENT_MNGR_API) {
        if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
          if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN}`
          }
        } else if (Object.keys(selectScop).length > 0) {
          accessStr = `${RouteAccess.CONTENT_MNGR} - ${selectScop.role}`
        } else {
          accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.NO_ACCESS}`
        }
      } else {
        if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
          if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN}`
          }
        } else if (Object.keys(selectScop).length > 0) {
          accessStr = `${RouteAccess.USER} - ${selectScop.role}`
        } else {
          accessStr = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
        }
      }
    }
    if (accessStr !== '') {
      let userPay = JSON.parse(localStorage.getItem('userPayload'))
      userPay.role = accessStr
      userPay.AllAccessData = acc
      userPay.clusterId = Object.keys(selectCls).length > 0 ? selectCls.clusterId : ''
      userPay.scope_id = Object.keys(selectScop).length > 0 ? selectScop.scope_id : ''
      userPay.selectedCluster = selectCls
      userPay.selectedScope = selectScop
      localStorage.setItem('UserAcc', accessStr)
      localStorage.setItem('userPayload', JSON.stringify(userPay))
      this.props.updateUserRole(accessStr)
    }
    // window.location.reload(false)

    this.props.updateAcc(dat)
  }

  getClusterDetails = () => {
    var data = { ssid: this.state.SSID }
    Scopes.getUserAccessDetails(data, this.state.SSID)
      .then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry('access')
        }
        if (response.data.status === 'success') {
          var getAccData = response
          if (
            localStorage.getItem('UserAcc').includes(`${RouteAccess.ROOT} - `) ||
            localStorage.getItem('UserAcc').includes(`${RouteAccess.CONTENT_MNGR} - `) ||
            (getAccData.data.data?.access?.length > 0 &&
              getAccData.data.data.access.filter(d => d.access_type === RouteAccess.ADMINISTRATOR)
                .length > 0)
          ) {
            let params = {
              size: 1000,
              query: '',
              add_filter: [],
              page: 1,
            }
            ClusterService.getTenantList(this.state.SSID, params)
              .then(response => {
                if (
                  response.data.status === 'invalid' ||
                  (response.data.status === 'error' &&
                    (response.data.message === 'User Invalid' ||
                      response.data.message === 'Invalid'))
                ) {
                  Common.sessionExpiry('access')
                }
                if (response.data.status === 'success') {
                  if (response.data.data.length === 0) {
                    // accRole = 'Root - Init' // No tenants created yet so redirect Root user
                  } // with the 'Root - Init' access to  tenants list page to create a first tenant.
                  else {
                    // create a access object to process further
                    var accessMap = {}
                    if (getAccData.data?.data?.access?.length > 0) {
                      getAccData.data.data.access.map(d => (accessMap[d.clusterId] = d))
                    } else if (localStorage.getItem('UserAcc').includes(`${RouteAccess.ROOT} - `)) {
                      getAccData.data.data.isRoot = true
                    } else {
                      getAccData.data.data.userType = RouteAccess.CONTENT_MNGR_API
                    }
                    let tmpAccessList = []
                    let tenantsAccessMap = {}
                    response.data.data.map(d => {
                      let accessDetails = {
                        access_type: accessMap[d['clusterId']]
                          ? accessMap[d['clusterId']].access_type
                          : RouteAccess.NO_ACCESS,
                        clusterId: d['clusterId'],
                        clusterName: d['clusterName'],
                        licenseType: d['licenseType'] ? d['licenseType'] : '',
                        productType: d['productType'] ? d['productType'] : '',
                        scope_access: d.scope_list
                          .filter(d => d.is_enabled)
                          .map(d => {
                            let tmpScopeD = {
                              scope_id: d.scope_id,
                              scope_name: d.scope_name,
                              role: RouteAccess.NO_ACCESS,
                            }
                            if (accessMap[d['cluster_id']]?.scope_access?.length > 0) {
                              accessMap[d['cluster_id']].scope_access.map(d1 => {
                                if (d1.scope_id === d.scope_id) {
                                  tmpScopeD.role = d1.role
                                }
                              })
                            }
                            return tmpScopeD
                          }),
                      }
                      tenantsAccessMap[d.clusterId] = d
                      tmpAccessList.push(accessDetails)
                    })
                    if (getAccData.data.data?.access?.length > 0) {
                      getAccData.data.data.access.map(d => {
                        if (!tenantsAccessMap[d.clusterId]) {
                          tmpAccessList.push(d)
                        }
                      })
                    }
                    getAccData.data.data.access = tmpAccessList
                    this.updateUserAccessAndClusterScope(getAccData)
                  }
                }
                if (response.data.status === 'failed') {
                  if (response.data.message === 'user not authorised') {
                    Common.showNotifications(
                      'error',
                      <div>You have no rights to access this page.</div>,
                    )
                    Common.sessionExpiry()
                  }
                  Common.showNotifications('error', 'Connections failed')
                }
              })
              .catch(error => {
                if (error.response !== undefined && error.response !== 'undefined') {
                  if (
                    error.response.data.status === 'invalid' ||
                    (error.response.data.status === 'error' &&
                      error.response.data.message.indexOf('Invalid') > -1)
                  ) {
                    Common.sessionExpiry('access')
                  }
                }
                Common.showNotifications('error', 'Something went wrong')
              })
          } else {
            if (getAccData.data.data?.access?.length > 0) {
              this.updateUserAccessAndClusterScope(getAccData)
            }
          }
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.showNotifications('error', <div>You have no rights to access this page.</div>)
            Common.sessionExpiry()
          }
          Common.showNotifications('error', 'Connections failed')
        }
      })
      .catch(error => {
        if (error.response !== undefined && error.response !== 'undefined') {
          if (
            error.response.data.status === 'invalid' ||
            (error.response.data.status === 'error' &&
              error.response.data.message.indexOf('Invalid') > -1)
          ) {
            Common.sessionExpiry('access')
          }
        }
        Common.showNotifications('error', 'Something went wrong')
      })
  }

  componentDidMount() {
    RouteAccess.routes.map(d => (this.state.routesMap[d.urlEnd] = d))
    this.getClusterDetails()
    // warm the hover icon so the first hover does not flash an empty image
    new Image().src = blooCommandIconPink
  }

  clusterIp = () => {
    AuthAPI.clusters(this.state.SSID)
      .then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry()
        }
        if (response.data.status === 'success') {
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.showNotifications('error', <div>You have no rights to access this page.</div>)
            Common.sessionExpiry()
          }
          Common.showNotifications('error', 'Connections failed')
        }
      })
      .catch(error => {
        if (error.response !== undefined && error.response !== 'undefined') {
          if (
            error.response.data.status === 'error' &&
            error.response.data.message.indexOf('Invalid') > -1
          ) {
            Common.sessionExpiry()
          }
        }
      })
  }

  check_get_user_path = path => {
    let userPayload = JSON.parse(localStorage.getItem('userPayload'))
    if (path.includes('no-access')) {
      if (
        userPayload.role.includes(RouteAccess.SEC_ENG) ||
        userPayload.role.includes(RouteAccess.SEC_ANALYST)
      ) {
        path = '/workbook/new'
      } else if (userPayload.role.includes(RouteAccess.ROOT)) {
        path = '/admin/components'
      } else if (userPayload.role.includes(RouteAccess.TENANT_ADMIN)) {
        path = '/admin/tenants/list'
      } else if (userPayload.role.includes(RouteAccess.ORG_ADMIN)) {
        path = '/admin/organizations/list'
      } else if (userPayload.role.includes(RouteAccess.CONTENT_MNGR)) {
        path = '/system/streamfieldaddition'
      } else {
        path = '/no-access/auth/no-access'
      }
    } else {
      if (
        this.state.routesMap[path] &&
        this.state.routesMap[path].roles.includes(userPayload.role)
      ) {
        path = path
      } else {
        if (
          userPayload.role.includes(RouteAccess.SEC_ENG) ||
          userPayload.role.includes(RouteAccess.SEC_ANALYST)
        ) {
          path = '/workbook/new'
        } else if (userPayload.role.includes(RouteAccess.ROOT)) {
          path = '/admin/components'
        } else if (userPayload.role.includes(RouteAccess.TENANT_ADMIN)) {
          path = '/admin/tenants/list'
        } else if (userPayload.role.includes(RouteAccess.ORG_ADMIN)) {
          path = '/admin/organizations/list'
        } else if (userPayload.role.includes(RouteAccess.CONTENT_MNGR)) {
          path = '/system/streamfieldaddition'
        } else {
          path = '/no-access/auth/no-access'
        }
      }
    }
    return path
  }

  handleBlooCommandClick = e => {
    e.preventDefault()
    axios
      .get(BLOO_COMMAND_URL, {
        headers: {
          SSID: localStorage.getItem('SSID'),
        },
      })
      .then(response => {
        const redirectUrl = response.data.data.redirect_url
        window.open(redirectUrl, '_self')
      })
      .catch(() => {
        Common.showNotifications('error', 'Unable to switch to Bloo Command right now')
      })
  }

  setScope = scope => {
    var route = ''
    var cluster = this.state.clusterName
    const { location, history } = this.props
    this.setState({ SelectedScope: scope })
    this.props.updateScopeData(scope)
    var userPayload = JSON.parse(localStorage.getItem('userPayload'))
    var dat = { cluster: cluster, scope: scope }
    userPayload.licenseType = cluster.licenseType

    let roleSplit = userPayload.role.split('-')
    roleSplit[roleSplit.length - 1] = ' ' + scope.role
    userPayload.role = roleSplit.join('-')

    userPayload.clusterId = cluster.clusterId
    userPayload.scope_id = scope.scope_id
    userPayload.selectedScope = scope
    localStorage.setItem('userPayload', JSON.stringify(userPayload))
    localStorage.setItem('UserAcc', userPayload.role)
    var accessStr = ''
    if (this.props.AllAccessData.data.isRoot) {
      if (Object.keys(scope).length > 0) {
        if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
          accessStr = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${scope.role}`
        } else {
          accessStr = `${RouteAccess.ROOT} - ${scope.role}`
        }
      } else {
        accessStr = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
      }
    } else if (this.props.AllAccessData.data.isOrgAdmin) {
      if (Object.keys(scope).length > 0) {
        if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
          accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${scope.role}`
        } else {
          accessStr = `${RouteAccess.ORG_ADMIN} - ${scope.role}`
        }
      } else {
        accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
      }
    } else if (this.props.AllAccessData.data.userType === RouteAccess.CONTENT_MNGR_API) {
      if (Object.keys(scope).length > 0) {
        if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
          accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${scope.role}`
        } else {
          accessStr = `${RouteAccess.CONTENT_MNGR} - ${scope.role}`
        }
      } else {
        accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.NO_ACCESS}`
      }
    } else {
      if (Object.keys(scope).length > 0) {
        if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
          accessStr = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${scope.role}`
        } else {
          accessStr = `${RouteAccess.USER} - ${scope.role}`
        }
      } else {
        accessStr = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
      }
    }
    if (accessStr !== '') {
      localStorage.setItem('UserAcc', accessStr)
      this.props.updateUserRole(accessStr)
    }
    // window.location.reload(false)
    this.props.updateAcc(dat)
    if (RouteAccess.VIEWER_ROLES.includes(userPayload.role)) {
      localStorage.setItem('UserAcc', userPayload.role)
      let path = this.check_get_user_path('/dashboard')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/clusters/') > -1) {
      let path = this.check_get_user_path('/admin/clusters')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/components/') > -1) {
      let path = this.check_get_user_path('/admin/components')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/user/') > -1) {
      let path = this.check_get_user_path('/admin/user/list')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/organizations/') > -1) {
      let path = this.check_get_user_path('/admin/organizations/list')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/dashboard') > -1) {
      let path = this.check_get_user_path('/dashboard')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/mitre_attack') > -1) {
      let path = this.check_get_user_path('/mitre_attack')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/uba') > -1) {
      let path = this.check_get_user_path('/home')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/system/models') > -1) {
      let path = this.check_get_user_path('/system/models')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/cases') > -1) {
      let path = this.check_get_user_path('/incident/cases')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/extraction') > -1) {
      let path = this.check_get_user_path('/system/extraction')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/stream') > -1) {
      let path = this.check_get_user_path('/home')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/enrichment') > -1) {
      let path = this.check_get_user_path('/system/enrichment')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/workbook') > -1) {
      let path = this.check_get_user_path('/workbook/new')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/home') > -1) {
      let path = this.check_get_user_path('/home')
      if (path.includes('/home')) {
        route =
          '/' +
          cluster.clusterId +
          '/' +
          scope.scope_id +
          path +
          '/' +
          scope.scope_id +
          '/' +
          cluster.clusterId
      } else {
        route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      }
      history.push(route)
    } else if (location.pathname.indexOf('/no-access/auth/no-access') > -1) {
      let path = this.check_get_user_path('/no-access/auth/no-access')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else if (location.pathname.indexOf('/incident/signals') > -1) {
      let path = this.check_get_user_path('/incident/signals')
      route = '/' + cluster.clusterId + '/' + scope.scope_id + path
      history.push(route)
    } else {
      let arr = location.pathname.replace('/', '').split('/')
      let finalroute = '/'
      for (var i = 0; i < arr.length; i++) {
        if (i === 0) {
          finalroute = finalroute + cluster.clusterId
        } else if (i === 1) {
          finalroute = finalroute + scope.scope_id
        } else {
          finalroute = finalroute + arr[i]
        }
        if (i + 1 !== arr.length) {
          finalroute = finalroute + '/'
        }
      }
      route = finalroute
      history.push(route)
    }

    window.location.reload(false)
  }

  getRouteUrl = (cluster, scope, location) => {
    var userPayload = JSON.parse(localStorage.getItem('userPayload'))
    var scopeID = Object.keys(scope).length > 0 ? '/' + scope.scope_id : ''
    var route = ''
    if (location.pathname.indexOf('/system/collection_status') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/system/collection_status')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/system/collection_status')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/system/utilization') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/system/utilization')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/system/utilization')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/system/') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/home')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/clusters') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/admin/clusters')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/components') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/user') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/admin/user/list')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/organizations') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/admin/organizations/list')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/dashboard') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/dashboard')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/system/models') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/system/models')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/cases') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/incident/cases')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/extraction') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/system/extraction')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/mitre_attack') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/mitre_attack')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/stream') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/stream/list')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/enrichment') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/system/enrichment')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/workbook') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/workbook/new')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/eba') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/eba')
        route = '/' + cluster.clusterId + scopeID + path
      }
    } else if (location.pathname.indexOf('/home') > -1) {
      if (scopeID === '') {
        let path = this.check_get_user_path('/admin/components')
        route = '/' + cluster.clusterId + path
      } else {
        let path = this.check_get_user_path('/home')
        route = '/' + cluster.clusterId + scopeID + path + scopeID + '/' + cluster.clusterId
      }
    } else if (location.pathname.indexOf('/no-access/auth/no-access') > -1) {
      let path = this.check_get_user_path('/no-access/auth/no-access')
      route = '/' + cluster.clusterId + scopeID + path
    } else if (location.pathname.indexOf('/incident/signals') > -1) {
      let path = this.check_get_user_path('/incident/signals')
      route = '/' + cluster.clusterId + scopeID + path
    } else {
      let arr = location.pathname.replace('/', '').split('/')
      let finalroute = '/'
      for (var i = 0; i < arr.length; i++) {
        if (i === 0) {
          finalroute = finalroute + cluster.clusterId
        } else if (i === 1 && scopeID !== '') {
          finalroute = finalroute + scope.scope_id
        } else {
          finalroute = finalroute + arr[i]
        }
        if (i + 1 !== arr.length) {
          finalroute = finalroute + '/'
        }
      }
      //route = location.pathname.replace(/\/[A-za-z0-9-]+\//, '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id +'/')
      route = finalroute
      // console.log(route)
    }
    return route
  }

  changeCluster = cluster => {
    const { match, location, history } = this.props
    var route = ''
    if (cluster !== null) {
      var userPayload = JSON.parse(localStorage.getItem('userPayload'))
      userPayload['licenseType'] = cluster.licenseType
      var userAcc = ''
      if (cluster.scope_access.length > 0) {
        if (this.state.accessData.data.isRoot === true) {
          if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
            userAcc = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${cluster.scope_access[0].role}`
          } else {
            userAcc = `${RouteAccess.ROOT} - ${cluster.scope_access[0].role}`
          }
        } else if (this.state.accessData.data.isOrgAdmin === true) {
          if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
            userAcc = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${cluster.scope_access[0].role}`
          } else {
            userAcc = `${RouteAccess.ORG_ADMIN} - ${cluster.scope_access[0].role}`
          }
        } else if (this.state.accessData.data.userType === RouteAccess.CONTENT_MNGR_API) {
          if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
            userAcc = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${cluster.scope_access[0].role}`
          } else {
            userAcc = `${RouteAccess.CONTENT_MNGR} - ${cluster.scope_access[0].role}`
          }
        } else {
          if (cluster.access_type === RouteAccess.ADMINISTRATOR) {
            userAcc = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${cluster.scope_access[0].role}`
          } else {
            userAcc = `${RouteAccess.USER} - ${cluster.scope_access[0].role}`
          }
        }
      } else {
        if (this.state.accessData.data.isRoot === true) {
          userAcc = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
        } else if (this.state.accessData.data.isOrgAdmin === true) {
          userAcc = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
        } else if (this.state.accessData.data.userType === RouteAccess.CONTENT_MNGR_API) {
          userAcc = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.NO_ACCESS}`
        } else {
          userAcc = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
        }
      }
      if (userAcc !== '') {
        userPayload.role = userAcc
        userPayload.clusterId = cluster.clusterId
        userPayload.selectedCluster = cluster
        userPayload.scope_id =
          cluster.scope_access.length > 0 ? cluster.scope_access[0].scope_id : ''
        localStorage.setItem('UserAcc', userAcc)
        localStorage.setItem('userPayload', JSON.stringify(userPayload))
      }
    }
    if (cluster.scope_access.length > 0) {
      for (var j = 0; j < cluster.scope_access.length; j++) {
        if (cluster.scope_access[j].role === RouteAccess.VIEWER) {
          let path = this.check_get_user_path('/dashboard')
          route = '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id + path
          break
        } else {
          let path = this.check_get_user_path('/home')
          if (path.includes('/home')) {
            route =
              '/' +
              cluster.clusterId +
              '/' +
              cluster.scope_access[j].scope_id +
              path +
              '/' +
              cluster.scope_access[j].scope_id +
              '/' +
              cluster.clusterId
          } else {
            route = '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id + path
          }
          break
        }
      }
      this.setState({ clusterName: cluster.clusterName }, () => {
        return this.state.clusterName
      })
    } else {
      if (this.state.accessData.data.isRoot === true) {
        route = this.getRouteUrl(cluster, {}, location)
      } else {
        route = '/' + cluster.clusterId + '/no-access/auth/no-access'
      }
    }
    history.push(route)
    window.location.reload(false)
  }

  upDateAccSelection = dataAcc => {
    var responseData = dataAcc
    var clusterUrl = window.location.hash.replace('#/', '').split('/')[0]
    var scopeurl = window.location.hash.replace('#/', '').split('/')[1]
    var selectCls = {}
    var selectScop = {}
    for (var i = 0; i < responseData.data.access.length; i++) {
      if (responseData.data.access[i].clusterId === clusterUrl) {
        selectCls = responseData.data.access[i]
        for (var j = 0; j < responseData.data.access[i].scope_access.length; j++) {
          if (responseData.data.access[i].scope_access[j].scope_id === scopeurl) {
            selectScop = responseData.data.access[i].scope_access[j]
          }
        }
      }
    }
    let acc = responseData
    var dat = { cluster: selectCls, scope: selectScop }
    this.props.updateScopeData(selectScop)
    this.props.updateSelection(dat, this.props.AllAccessData)
    this.props.updateAcc(dat)
    var accessStr = ''
    var userPayload = JSON.parse(localStorage.getItem('userPayload'))
    if (acc.data.access.length === 0 && acc.data.isRoot && this.state.tenantsData.length === 0) {
      accessStr = `${RouteAccess.ROOT} - ${RouteAccess.INIT}` // No tenants created yet so redirect Root user
      // with the 'Root - Init' access to  tenants list page to create a first tenant.
    } else {
      if (acc.data) {
        if (acc.data.isRoot) {
          if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
            if (Object.keys(selectScop).length > 0) {
              accessStr = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
            } else {
              accessStr = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN}`
            }
          } else if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.ROOT} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
          }
        } else if (acc.data.isOrgAdmin) {
          if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
            if (Object.keys(selectScop).length > 0) {
              accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
            } else {
              accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN}`
            }
          } else if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.ORG_ADMIN} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
          }
        } else if (acc.data.userType === RouteAccess.CONTENT_MNGR_API) {
          if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
            if (Object.keys(selectScop).length > 0) {
              accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
            } else {
              accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN}`
            }
          } else if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.CONTENT_MNGR} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.NO_ACCESS}`
          }
        } else {
          if (selectCls.access_type === RouteAccess.ADMINISTRATOR) {
            if (Object.keys(selectScop).length > 0) {
              accessStr = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${selectScop.role}`
            } else {
              accessStr = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN}`
            }
          } else if (Object.keys(selectScop).length > 0) {
            accessStr = `${RouteAccess.USER} - ${selectScop.role}`
          } else {
            accessStr = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
          }
        }
      }
    }
    if (accessStr !== '') {
      userPayload.role = accessStr
      this.props.updateUserRole(accessStr)
      userPayload.licenseType = selectCls.licenseType
      userPayload.clusterId = selectCls.clusterId
      userPayload.selectedScope = selectScop
      userPayload.scope_id = Object.keys(selectScop).length > 0 ? selectScop.scope_id : ''
      localStorage.setItem('userPayload', JSON.stringify(userPayload))
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      var current = this.props.location.pathname.split('/')
      var next = nextProps.location.pathname.split('/')
      if (typeof this.props.AllAccessData !== 'undefined') {
        this.upDateAccSelection(this.props.AllAccessData)
      }
    }
  }

  componentDidUpdate() {
    var scopeurl = window.location.hash.replace('#/', '').split('/')[1]
    var clusterUrl = window.location.hash.replace('#/', '').split('/')[0]
    var currentCluster = this.props.location.pathname.split('/')[1]
    var currentScope = this.props.location.pathname.split('/')[2]
    if (clusterUrl !== currentCluster) {
      window.location.reload(false)
    } else {
      if (scopeurl !== currentScope && !window.location.hash.includes('auth/login')) {
        window.location.reload(false)
      }
    }
  }

  render() {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {typeof this.props.AllAccessData !== 'undefined' ? (
          <>
            <Button
              type="link"
              onClick={this.handleBlooCommandClick}
              onMouseEnter={() => this.setState({ blooCommandHover: true })}
              onMouseLeave={() => this.setState({ blooCommandHover: false })}
              onFocus={() => this.setState({ blooCommandHover: true })}
              onBlur={() => this.setState({ blooCommandHover: false })}
            >
              <span style={{ marginRight: '5px' }}>
                <img
                  src={this.state.blooCommandHover ? blooCommandIconPink : blooCommandIcon}
                  alt=""
                  className={style.blooIcon}
                />
              </span>
              <span style={{ lineHeight: '28px' }}>Bloo Command (Beta)</span>
            </Button>
            {Object.keys(this.props.AllAccessData).length > 0 ? (
              this.props.AllAccessData.data.access.length > 1 ? (
                <Dropdown
                  trigger={['click']}
                  defaultSelectedKeys={this.props.selectedCluster.clusterId}
                  overlay={
                    <Menu
                      style={{
                        width: '150px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'left',
                      }}
                    >
                      {this.props.AllAccessData.data.access.length > 1
                        ? this.props.AllAccessData.data.access.map((item, index) => (
                            <Menu.Item
                              onClick={() => this.changeCluster(item)}
                              key={item.clusterId}
                              className={
                                this.props.selectedCluster.clusterId === item.clusterId
                                  ? 'topbarSelect'
                                  : ''
                              }
                              style={{
                                color:
                                  this.props.selectedCluster.clusterId === item.clusterId
                                    ? 'deeepskyblue'
                                    : '#d3d3d3',
                              }}
                            >
                              {item.clusterName}
                            </Menu.Item>
                          ))
                        : null}
                    </Menu>
                  }
                >
                  <Button type="link" onClick={e => e.preventDefault()}>
                    <span style={{ marginRight: '5px' }}>
                      <i className="fal fa-network-wired" />
                    </span>
                    {this.props.selectedCluster.clusterName}
                    {this.props.AllAccessData.data.access.length > 1 ? (
                      <i style={{ marginLeft: '5px' }} className={'fal fa-chevron-down'}></i>
                    ) : null}
                  </Button>
                </Dropdown>
              ) : (
                <Button type="link" onClick={e => e.preventDefault()}>
                  <span style={{ marginRight: '5px' }}>
                    <i className="fal fa-network-wired" />
                  </span>
                  {this.props.selectedCluster.clusterName}
                  {this.props.AllAccessData.data.access.length > 1 ? (
                    <i style={{ marginLeft: '5px' }} className={'fal fa-chevron-down'}></i>
                  ) : null}
                </Button>
              )
            ) : null}
            {!(
              window.location.toString().includes('admin/clusters') ||
              window.location.toString().includes('admin/user') ||
              window.location.toString().includes('admin/organizations') ||
              window.location.toString().includes('admin/components') ||
              window.location.toString().includes('admin/smtp') ||
              window.location.toString().includes('admin/switchboard')
            ) &&
              (typeof this.props.selectedCluster.scope_access !== 'undefined' ? (
                this.props.selectedCluster.scope_access.length > 1 ? (
                  <>
                    {/* / */}
                    <Dropdown
                      trigger={['click']}
                      placement="bottomRight"
                      defaultSelectedKeys={this.props.selectedScope?.scope_id}
                      overlay={
                        <Menu
                          style={{
                            // borderTop: '2px solid #1890ff',
                            // borderRadius: '4px',
                            width: '150px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'left',
                          }}
                        >
                          {this.props.selectedCluster.scope_access.length > 1
                            ? this.props.selectedCluster.scope_access.map(item => (
                                <Menu.Item
                                  key={item.scope_id}
                                  className={
                                    this.props.selectedScope?.scope_id === item.scope_id
                                      ? 'topbarSelect'
                                      : ''
                                  }
                                  onClick={() => {
                                    this.setScope(item)
                                  }}
                                >
                                  {item.scope_name}
                                </Menu.Item>
                              ))
                            : null}
                        </Menu>
                      }
                    >
                      {this.props.selectedScope?.scope_name &&
                        this.props.selectedScope?.scope_name.length > 0 && (
                          <Button type="link" onClick={e => e.preventDefault()}>
                            <span style={{ marginRight: '5px' }}>
                              <i className="fal fa-bullseye-pointer" />
                            </span>
                            {this.props.selectedScope?.scope_name}
                            {this.props.selectedCluster.scope_access.length > 1 ? (
                              <i
                                style={{ marginLeft: '5px' }}
                                className={'fal fa-chevron-down'}
                              ></i>
                            ) : null}
                          </Button>
                        )}
                    </Dropdown>
                  </>
                ) : (
                  this.props.selectedScope?.scope_name &&
                  this.props.selectedScope?.scope_name.length > 0 && (
                    <Button
                      type="link"
                      onClick={e => e.preventDefault()}
                      style={{ cursor: 'default' }}
                    >
                      <span style={{ marginRight: '5px' }}>
                        <i className="fal fa-bullseye-pointer" />
                      </span>
                      {this.props.selectedScope?.scope_name}
                      {this.props.selectedCluster.scope_access.length > 1 ? (
                        <i style={{ marginLeft: '5px' }} className={'fal fa-chevron-down'}></i>
                      ) : null}
                    </Button>
                  )
                )
              ) : null)}
          </>
        ) : null}
      </div>
    )
  }
}

export default ClusterScopetab
